import { render, staticRenderFns } from "./Renovar.vue?vue&type=template&id=4f04e006"
import script from "./Renovar.vue?vue&type=script&lang=js"
export * from "./Renovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports